module.exports = __webpack_public_path__ + "static/img/5.a9f0a35.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/zh/5.png
// module id = y8WG
// module chunks = 0